/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'
const BASE_URL = 'v1/manage/salary'
export default {

  getBillList(data) {
    return request.get(`/${BASE_URL}/bill`, data)
  },
  
  postBillStatus(id,data) {
    return request.put(`${BASE_URL}/bill/update/${id}`, data)
  },
  
}